import React, { useRef } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const regex = new RegExp("[0-9]");

export function PinInput({ nextfocus, onChange, length, ...props }) {
  const refs = useRef([]);

  const handleChange = (index) => (event) => {
    const { data } = event.nativeEvent;
    const nextPin = refs.current[index + 1] || nextfocus?.current;
    if (!regex.test(data))
      return (event.target.value = event.target.value.replace(/\D/g, ""));
    if (data && nextPin) nextPin.focus();
    else event.target.blur();
    event.target.value = data;
    onChange(refs.current.map(({ value }) => value).join(""));
  };

  const handleFocus = (index) => () => {
    const prevPin = refs?.current[index - 1];
    if (!prevPin) return;
    const val = prevPin?.value;
    if (!val) prevPin.focus();
  };

  const handleKeyDown = (index) => (event) => {
    const { key } = event;
    const prevPin = refs.current[index - 1];
    const nextPin = refs.current[index + 1];
    switch (key) {
      case "Backspace":
        onChange(
          refs.current
            .map(({ value }) => value)
            .join("")
            .slice(0, -1)
        );
        if (!refs.current[index].value) prevPin?.focus();
        break;
      case "ArrowLeft":
        prevPin?.focus();
        break;
      case "ArrowRight":
        nextPin?.focus();
        break;
      default:
        break;
    }
  };

  return (
    <Utility>
      <PinInputContainer {...props}>
        {[...Array(length)].map((_, index) => (
          <Pin
            className="pin"
            type="tel"
            ref={(el) => (refs.current[index] = el)}
            key={index}
            onChange={handleChange(index)}
            onKeyDown={handleKeyDown(index)}
            onFocus={handleFocus(index)}
          />
        ))}
      </PinInputContainer>
    </Utility>
  );
}

PinInput.propTypes = {
  ContainerRef: PropTypes.object,
  nextfocus: PropTypes.object,
  onChange: PropTypes.func,
  fontSize: PropTypes.string,
};

PinInput.defaultProps = {
  fontSize: "1.125rem",
};

const PinInputContainer = styled.div`
  --field-line-height: 2rem;
  --field-padding-block: 0.813rem;
  --field-font-size: ${({ fontSize }) => fontSize};
  --field-font-family: "Poppins";
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 5px;
  direction: ltr;
`;

const GeneralInput = styled.input`
  border: 1px solid transparent;
  transition: all 250ms ease-in;
  background-color: #f5f6f8;
  border-radius: 10px;
  caret-color: #81a0f6;
  outline: none;
  font-size: var(--field-font-size);
  font-family: var(--field-font-family);
  line-height: var(--field-line-height);
  padding-block: var(--field-padding-block);
`;

const Pin = styled(GeneralInput)`
  padding-inline: var(--field-padding-block);
  width: var(--field-line-height);
  text-align: center;
`;

const Utility = styled.div`
  .invalid {
    & > .pin {
      border-color: var(--invalid);
    }
  }
`;
